import React  from 'react';
import { Layout, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import './footer.css';

export const Footer = ({className, pastorEmail, pastorPhone}) => {
  return(
    <Layout.Footer className={`footer ${className}`}>
      <Row>
        <Col span={8}>
          <Link className="footer-item" to="/privacyPolicy">Focused Evangelism</Link>
        </Col>
        <Col span={8} className="footer-item-group footer-item-group_middle">
          <Row>
            <Col>{pastorEmail}</Col>
            <Col>{pastorPhone}</Col>
          </Row>
        </Col>
        <Col span={8} className="footer-item-group footer-item-group_last">
          <div className="footer-item footer-item_divider" />
          <Link className="footer-item" to="/privacyPolicy">Privacy Policy</Link>
        </Col>
      </Row>
    </Layout.Footer>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/footer/footer.js